<template>
  <div>
    <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
      <div class="flex flex row">
        <avatar :user-display="topic.userDisplay"></avatar>
        <div class="ml-2 flex-grow">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            {{ topic.topic }}
          </h3>
          <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
            Started by {{ topic.userDisplay }}
            <span v-if="email">{{ email }}</span
            ><span
              v-else
              class="text-red underline cursor-pointer"
              @click="fetchEmail"
              >Fetch Email</span
            >
          </p>
        </div>
        <div
          class="flex-grow-0 bg-darkBlue rounded  text-xl tracking-wide p-2 font-open-sans cursor-pointer "
          @click="approve(topic.id)"
        >
          <span class="text-white ">Approve</span>
        </div>
      </div>
    </div>
    <vue-markdown
      :source="topic.body"
      :anchorAttributes="{ target: '_blank' }"
      class="px-4 py-5 sm:px-6"
    ></vue-markdown>
  </div>
</template>

<script>
import { approveTopic, getUser } from "../utils/functions";

import Avatar from "./Avatar";
import VueMarkdown from "vue-markdown";

export default {
  name: "TopicApprovalRow",
  components: {
    Avatar,
    VueMarkdown
  },
  props: {
    topic: {
      type: Object
    }
  },
  data() {
    return {
      email: ""
    };
  },
  methods: {
    approve(id) {
      approveTopic(id);
    },
    fetchEmail() {
      getUser(this.topic.user)
        .then(res => {
          this.email = res.data.email;
        })
        .catch(err => console.error(err));
    }
  }
};
</script>

<style scoped></style>
